import { formatCurrency } from '@if/core/utils'
import * as yup from '@if/core/yup'
import { PageContainer } from '@if/mui'
import { useGetBankJob } from '@src/api/lender-payment/bank-jobs-api'
import BankJobLines from '@src/components/Disburse/BankJobLines'
import { useCompany } from '@src/services/company-hooks'
import { useTranslation } from 'react-i18next'

const BANK_JOB_PARAMS = ['bankJobId'] as const

const bankJobParamsSchema = yup.object({
  bankJobId: yup.integer().positive().required(),
})

type BankJobParams = yup.InferSubmit<typeof bankJobParamsSchema>

const useBankJobResource = ({ bankJobId }: BankJobParams) => {
  const company = useCompany()
  return { bankJob: useGetBankJob(company, bankJobId) }
}

// One deposit of the disbursement history (ACP file, cheque or direct deposit): its summary, then the
// bank job lines it paid.
const BankJobPage = () => {
  const { t } = useTranslation()
  const company = useCompany()

  return (
    <PageContainer
      params={BANK_JOB_PARAMS}
      paramsSchema={bankJobParamsSchema}
      usePrimary={useBankJobResource}
      back={{ to: `/${company}/disbursements/history`, label: t('disburse.tabs.history') }}
      title={({ bankJob }) => t('disburse.history.filePage.title', { fileNumber: bankJob.fileNumber })}
      subtitle={({ bankJob }) => [
        { label: t('disburse.history.columns.date'), value: bankJob.depositOn },
        { label: t('disburse.history.columns.createdBy'), value: bankJob.createdByFullName },
        { label: t('disburse.history.columns.amount'), value: formatCurrency(bankJob.amount) },
      ]}
    >
      {({ bankJob }) => <BankJobLines bankJobId={bankJob.bankJobId} />}
    </PageContainer>
  )
}

export default BankJobPage
